import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { CompaniesListInner } from './CompaniesListInner/CompaniesListInner';

export type CompaniesListProps =
  SliceComponentProps<Content.CompaniesListSlice>;

const CompaniesList = ({ slice }: CompaniesListProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <CompaniesListInner data={slice.primary} />
    </section>
  );
};

export default CompaniesList;
